import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { IMaskInput } from "react-imask";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Mail, Lock, User, Smartphone, IdCard } from "lucide-react";
import { Spin, Tooltip } from "antd";
import axios from "axios";
import { NumberParam, useQueryParams } from "use-query-params";

import Globais, { validateCelular, validateCPF } from "../../components/Globais";
import { numberPadrao } from "../../uteis/formatPhoneNumber";
import { useMessage } from "../../uteis/mensagens/useMessage";
import { useInteressadoAnuncio } from "../../components/FormLogin/hooks/useInteressadoAnuncio";
import info from "../../images/info.png";

const Container = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent; /* removido o gradiente */
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
    .phone-input {
  width: 100% !important;
  height: 2.5rem !important;
  border: 1px solid #888 !important;
  border-radius: 4px !important;
  font-size: 1rem !important;
  padding-left: 48px !important; /* ícone da bandeira */
  display: flex !important;
  align-items: center !important;
}

.react-tel-input .flag-dropdown {
  border: none !important;
  background: transparent !important;
}

.react-tel-input .country-list {
  z-index: 9999 !important;
}

@media (max-width: 768px) {
  .phone-input {
    font-size: 1rem !important;
    height: 2.8rem !important;
  }
}

`;
const FormWrapper = styled.div`
  background: #fff;
  width: 100%;
  max-width: 450px;
  border-radius: 16px;
  padding: 2rem 2.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.4s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Title = styled.h2`
  text-align: center;
  color: #003644;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const InputGroup = styled.div`
  position: relative;
  margin-bottom: 1.1rem;

  svg {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    color: #777;
  }

  input {
    width: 100%;
    padding: 0.8rem 0.8rem 0.8rem 2.5rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 1rem;
    outline: none;
    transition: border 0.2s, box-shadow 0.2s;

    &:focus {
      border-color: #0096c7;
      box-shadow: 0 0 0 2px rgba(0, 150, 199, 0.2);
    }
  }
`;

const Botao = styled.button`
  width: 100%;
  background: #0096c7;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.9rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 0.6rem;
  transition: background 0.3s;

  &:hover {
    background: #00b4d8;
  }

  &:disabled {
    background: #90e0ef;
    cursor: not-allowed;
  }
`;

const Links = styled.div`
  text-align: center;
  font-size: 0.9rem;
  margin-top: 1.5rem;

  a {
    color: #0096c7;
    text-decoration: none;
    font-weight: 500;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const CheckContainer = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.85rem;
  margin-top: 0.8rem;

  input {
    margin-top: 0.15rem;
  }

  a {
    color: #0096c7;
    text-decoration: underline;
  }

  
`;



export default function ViewCadastroDadosPessoais() {
  const [formData, setFormData] = useState({
    nome: "",
    sobrenome: "",
    email: "",
    celular: "",
    cpf: "",
    password: "",
    confirmSenha: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [deAcordo, setDeAcordo] = useState(false);
  const [phone, setPhone] = useState("");

  const { showSuccess, showError, showWarning, contextHolder } = useMessage();
  const aguardando = useRef(false);
  const { cadastrar } = useInteressadoAnuncio();
  const [param] = useQueryParams({ CTUId: NumberParam, ANUId: NumberParam });

  useEffect(() => {
    if (Globais.TITULO === "HOMOLOGAÇÃO") {
      showWarning(
        "Você está em um ambiente de testes. Redirecionando para a página principal..."
      );
      setTimeout(() => {
        document.location.href = "https://www.multicotas.com.br";
      }, 5000);
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handlePhoneChange = (value: string) => {
    setPhone(value);
    setFormData((prev) => ({ ...prev, celular: numberPadrao(value) }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    aguardando.current = true;

    const passwordValidator = require("password-validator");
    const schema = new passwordValidator()
      .is()
      .min(8)
      .has()
      .uppercase()
      .has()
      .lowercase()
      .has()
      .digits(1)
      .has()
      .not()
      .spaces();

    try {
      if (!window.navigator.onLine)
        return showWarning("Sem conexão com a internet!");
      if (validateCelular(formData.celular))
        return showWarning(validateCelular(formData.celular));
      if (validateCPF(formData.cpf)) return showWarning(validateCPF(formData.cpf));
      if (formData.password !== formData.confirmSenha)
        return showError("As senhas não coincidem!");
      if (!schema.validate(formData.password)) {
        const erros = schema.validate(formData.password, { list: true });
        const mensagens: Record<string, string> = {
          min: "A senha deve ter no mínimo 8 caracteres!",
          uppercase: "A senha deve conter ao menos uma letra maiúscula!",
          lowercase: "A senha deve conter ao menos uma letra minúscula!",
          digits: "A senha deve conter ao menos um número!",
          spaces: "A senha não deve conter espaços!",
        };
        return showWarning(mensagens[erros[0]] || "A senha não atende aos requisitos.");
      }

      setIsLoading(true);
      let response: any;

      if (param.CTUId) {
        // 🔹 Cadastro vindo de um anúncio
        response = await axios.post(`${Globais.DOMINIOBACK}/usuario/0/0`, formData);
        const responseCelular = await axios.get(
          `${Globais.DOMINIOBACK}/anuncio-propriedade/telefone/${param.ANUId}`
        );

        const data = {
          idAnuncio: param.ANUId,
          idUsuario: response.data.id,
        };

        const interessadoAnuncio = await cadastrar(data);
        if (interessadoAnuncio) {
          const currentTime = new Date().getTime();
          const expirationTime = currentTime + 60 * 1000;

          showSuccess("Cadastro realizado! Redirecionando...");
          setTimeout(() => {
            document.location.href = `${Globais.DOMINIOANUNCIO}/detalhes.html?id=${param.CTUId}&params=${responseCelular.data.CotasUsuariosTable.UsuarioTable.celular}&expires=${expirationTime}`;
          }, 1800);
          return;
        }
      } else {
        // 🔹 Cadastro normal
        response = await axios.post(`${Globais.DOMINIOBACK}/usuario/0/0`, formData);
      }

      if (response) {
        showSuccess("🎉 Cadastro realizado! Enviamos um link de ativação para o seu e-mail.");
        setTimeout(() => (document.location.href = "/verifiqueEmail"), 2500);
      }
    } catch (err: any) {
      console.error("Erro:", err);
      const code = err.response?.data?.code;
      const msg = err.response?.data?.error;
      switch (code) {
        case "EMAIL_DUPLICADO":
          showError("Já existe um cadastro com este e-mail.");
          break;
        case "CPF_DUPLICADO":
          showError("Já existe um cadastro com este CPF.");
          break;
        case "ENVIO_EMAIL_FALHOU":
          showError("Erro ao enviar o e-mail de ativação. Tente mais tarde.");
          break;
           case "CELULAR_DUPLICADO":
          showError("Já existe um cadastro com este número de celular.");
          break;

          case "PESSOA_DUPLICADA":
            showError("Já existe um usuário vinculado a estes dados.");
            break;
        default:
          showError(msg || "❌ Ocorreu um erro inesperado. Tente novamente.");
      }
    } finally {
      aguardando.current = false;
      setIsLoading(false);
    }
  };

  return (
    <Container>
      {contextHolder}
      <FormWrapper>
        <form onSubmit={handleSubmit}>
          <Title>Cadastro de dados pessoais</Title>

          <InputGroup>
            <User size={18} />
            <input
              type="text"
              id="nome"
              required
              placeholder="Nome"
              value={formData.nome}
              onChange={handleChange}
            />
          </InputGroup>

          <InputGroup>
            <User size={18} />
            <input
              type="text"
              id="sobrenome"
              required
              placeholder="Sobrenome"
              value={formData.sobrenome}
              onChange={handleChange}
            />
          </InputGroup>

          <InputGroup>
            <Mail size={18} />
            <input
              type="email"
              id="email"
              required
              placeholder="E-mail"
              value={formData.email}
              onChange={handleChange}
            />
          </InputGroup>

          <InputGroup>
            <Smartphone size={18} />
            <PhoneInput
              country={"br"}
              value={phone}
              onChange={handlePhoneChange}
              autoFormat={false}
              placeholder="Digite seu telefone"
              inputClass="phone-input"
              buttonClass="phone-input-button"
            />
          </InputGroup>

          <InputGroup>
            <IdCard size={18} />
            <IMaskInput
              mask="000.000.000-00"
              unmask={true}
              id="cpf"
              placeholder="CPF"
              value={formData.cpf}
              onAccept={(value) =>
                setFormData((prev) => ({ ...prev, cpf: String(value ?? "") }))
              }
              required
            />
          </InputGroup>

          <InputGroup>
            <Lock size={18} />
            <Tooltip title="A senha deve conter letras maiúsculas e minúsculas, ao menos um número e 8 caracteres.">
              <input
                type="password"
                id="password"
                required
                placeholder="Senha"
                value={formData.password}
                onChange={handleChange}
              />
            </Tooltip>
          </InputGroup>

          <InputGroup>
            <Lock size={18} />
            <input
              type="password"
              id="confirmSenha"
              required
              placeholder="Confirmar Senha"
              value={formData.confirmSenha}
              onChange={handleChange}
            />
          </InputGroup>

          <CheckContainer>
            <input
              type="checkbox"
              checked={deAcordo}
              onChange={() => setDeAcordo(!deAcordo)}
              required
            />
            <span>
              Li e concordo com a{" "}
              <a href="/politicaprivacidade" target="_blank" rel="noreferrer">
                Política de Privacidade
              </a>{" "}
              e os{" "}
              <a href="/termodeuso" target="_blank" rel="noreferrer">
                Termos de Uso
              </a>.
            </span>
          </CheckContainer>

          <Botao type="submit" disabled={!deAcordo || isLoading}>
            {isLoading ? <Spin size="small" /> : "Cadastrar"}
          </Botao>

          <Links>
            Já tem uma conta?{" "}
            <a href="/login" target="_blank">
              Acesse aqui
            </a>
          </Links>
        </form>
      </FormWrapper>
    </Container>
  );
}
